import { PROJECT_TYPES } from '../constants';

const CONSUMER_PAGES = [
  {
    path: `/${PROJECT_TYPES.SONAR.toLocaleLowerCase()}/:projectName`,
  },
  {
    path: `/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/:projectName`,
  },
  {
    path: `/${PROJECT_TYPES.RESONANCE.toLocaleLowerCase()}/:projectName`,
  },
  {
    path: `/${PROJECT_TYPES.GENIE.toLocaleLowerCase()}/:projectName`,
  },
  {
    path: `/${PROJECT_TYPES.GENIE_GO.toLocaleLowerCase()}/:projectName`,
  },
  {
    path: `/${PROJECT_TYPES.ID8.toLocaleLowerCase()}/:projectName`,
  },
];

export default CONSUMER_PAGES;
